package gr.tech.meetinggenie.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.styles.ModalContentAnimation
import gr.tech.meetinggenie.styles.ModalOverlayStyle
import org.jetbrains.compose.web.dom.Div

@Composable
fun ModalOverlay(
    isOpen: Boolean,
    onClose: () -> Unit,
    content: @Composable () -> Unit
) {
    if (!isOpen) return

    Div(attrs = ModalOverlayStyle.toModifier().onClick { onClose() }.toAttrs()) {
        Column(
            modifier = ModalContentAnimation.toModifier().attrsModifier {
                onClick { it.stopPropagation() }
            },
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            content()
        }
    }
}
